import { render, staticRenderFns } from "./ResearchAdvisorFilterComponent.vue?vue&type=template&id=7a2347e3&scoped=true&"
import script from "./ResearchAdvisorFilterComponent.vue?vue&type=script&lang=js&"
export * from "./ResearchAdvisorFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2347e3",
  null
  
)

export default component.exports